
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import 'react';
import Text from '../../Text/Text.js';
import { DropdownListItemTitleStyles } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var DropdownListItemTitle = function DropdownListItemTitle(_ref) {
  var label = _ref.label,
    level = _ref.level,
    isSearchable = _ref.isSearchable,
    textSize = _ref.textSize;
  return jsx("li", {
    "aria-disabled": "true",
    tabIndex: -1,
    css: DropdownListItemTitleStyles({
      level: level,
      isSearchable: isSearchable
    })
  }, typeof label === "string" ? jsx(Text, {
    fontSize: textSize,
    weight: "700",
    title: label
  }, label) : label);
};

export { DropdownListItemTitle as default };
//# sourceMappingURL=DropdownListItemTitle.js.map
